import { JobPost } from "@/types/jobPost";
import { Modal } from "../molecules";
import { Typography } from "@mui/material";
import { useUpdateSavedJob } from "@/hooks";

interface ApplicationStatusModalProps {
  jobPostId: JobPost["id"];
  jobPostTitle: JobPost["job_title"];
  companyName: JobPost["company"]["company_name"];
  showAppliedModal: boolean;
  handleLeftButtonClick: () => void;
}

export const ApplicationStatusModal = ({
  jobPostId,
  jobPostTitle,
  companyName,
  showAppliedModal,
  handleLeftButtonClick,
}: ApplicationStatusModalProps) => {
  const { updateSavedJob } = useUpdateSavedJob();

  const handleRightButtonClick = async () => {
    await updateSavedJob({
      job_post_id: jobPostId,
      application_status: "applied",
    });
    handleLeftButtonClick();
  };

  return (
    <Modal
      open={showAppliedModal}
      componentName="application-status"
      header={`You just visited ${jobPostTitle} at ${companyName}`}
      renderButtonSet
      handleRightButtonClick={handleRightButtonClick}
      rightButtonText="Yes"
      handleLeftButtonClick={handleLeftButtonClick}
      leftButtonText="No"
    >
      <Typography variant="h6">Did you end up applying?</Typography>
    </Modal>
  );
};
